<template>
  <div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
      <v-row class="pl-2 pr-2 mt-4">
        <v-col>
          <v-select 
            v-model="environmentSelect"
            :items="environments"
            item-text="description"
            item-value="id"
            :label="$tc('entities.environment.title')"
            return-object
          ></v-select>
        </v-col>

        
        <v-col v-if="kanbanTypeSelect === 'Resources'">
          <v-text-field
										:label="$tc('entities.environment.filter')"
										v-model="environmentSetor"
										clearable
									></v-text-field>
        </v-col>

        <v-col>
          <v-select 
            v-model="kanbanTypeSelect"
            @change="typeChange"
            :items="kanbanTypes"
            label="Kanban"
          ></v-select>
        </v-col>

        
      </v-row>
    <router-view></router-view>
  </div>
</template>


<script>
import environmentService from "@/services/environmentService";
export default {
  data() {
    return {
      alert: { alerts: [], type: "error" },
      kanbanTypes: ["Jobs", "Resources"],
      // kanbanTypes: ["Jobs", "Jobs Group", "Resources"],
      kanbanTypeSelect: "Jobs",
      environmentSelect: null,
      environmentSetor: null,
      environments: [],
    };
  },
  watch: {
    async environmentSelect() {
      if (this.$route.path !== "/kanban") await this.$router.push("kanban");
      this.navigate();
    },

    async environmentSetor(value){
      if (this.$route.path !== "/kanban") await this.$router.push("kanban");
      this.environmentSetor = value;
      this.navigate();
    }
  },
  methods: {
    navigate() {
      if (!(this.environmentSelect && this.kanbanTypeSelect)) return;
      let environmentId = this.environmentSelect.id;
      let environmentSetor = this.environmentSetor;
      if (this.kanbanTypeSelect == "Jobs")
        this.$router.push({ name: "KanbanJob", query: { environmentId } });
      else if (this.kanbanTypeSelect == "Jobs Group")
        this.$router.push({ name: "KanbanJobGroup", query: { environmentId } });
      else
        this.$router.push({ name: "KanbanResource", query: { environmentId: environmentId, setor: environmentSetor}});
    },
    typeChange() {
      this.navigate();
    },
    async getEnvironments() {
      let res = await environmentService.getByUser();
      if (res.success) {
        this.environments = res.data;
        if (this.environments.length == 1)
          this.environmentSelect = this.environments[0];
      } else {
        this.alert.alerts = res.data;
      }
    },
  },

  async mounted() {
    await this.getEnvironments();
  },
};
</script>